import Slider from './Slider.vue';

export default Slider;



// WEBPACK FOOTER //
// ./src/pages/profile/components/slider/index.ts